import React from 'react';
import { Typography, Box } from '@mui/material';

const statCards = [
  {
    title: 'Total Application',
    value: '25',
  },
  {
    title: 'Worked Time',
    value: '09:18:00',
    subValue: null,
  },
  {
    title: 'Avg. Activity',
    value: '28%',
  },
  {
    title: 'Project',
    value: '8',
  },
  {
    title: 'Session',
    value: '568',
  },
  {
    title: 'Unusual Application',
    value: '5',
  },
];

const AppDataCard = () => {
  return (

    <div className="row gy-0">
      <div className="col-xxl-12 d-flex flex-wrap gap-2">
        {statCards.map((stat, index) => (
          <Box
            key={index}
            className="card-body p-20 bg-base border d-flex flex-column justify-content-center rounded-3"
            sx={{ flex: { xl: '1 1 190px', lg: '1 1 240px', md: '1 1 230px', sm: '1 1 200px' }, minWidth: { xl: '190px', lg: '240px', md: '230px', sm: '200px' } }}
          >
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
              <div>
                <span className="mb-1 fw-medium text-secondary-light text-sm" style={{ fontFamily: 'Manrope' }}>
                  {stat.title}
                </span>
                <Typography variant='h6' className="text-primary-light" style={{  fontWeight: '600', color: '#373737', lineHeight: '1', fontFamily: 'Manrope' }}>
                  {stat.value}
                </Typography>
              </div>
            </div>

          </Box>
        ))}
      </div>
    </div>
  );
};

export default AppDataCard;
